
export const UsersUiPlugin = {
  install (app, options) {
    // TODO: add some validation
    // just add a route to the router for now... it's just a POC
    const { router, addSidebarItems } = options;

    router.addRoute({
      path: '/users/admin',
      name: 'userAdmin',
      component: () => import('../views/admin.vue'),
    });

    router.addRoute({
      path: '/users/register',
      name: 'userRegister',
      component: () => import('../views/register.vue'),
      meta: { layout: 'fullBleed', noAuth: true  },
    });

    router.addRoute({
      path: '/users/invite/:token',
      name: 'acceptInvite',
      component: () => import('../views/accept-invite.vue'),
      meta: { layout: 'fullBleed', noAuth: true  },
    });

    router.addRoute({
      path: '/users/forgotpassword',
      name: 'forgotPassword',
      component: () => import('../views/forgot-password.vue'),
      meta: { layout: 'fullBleed', noAuth: true },
    });

    router.addRoute({
      path: '/users/resetpassword/:token',
      name: 'resetPassword',
      component: () => import('../views/reset-password.vue'),
      meta: { layout: 'fullBleed', noAuth: true },
    });

    addSidebarItems([
      { text: 'Admin',        children: [
        { text: 'Users',      path: '/users/admin',  permissions: ['users.admin.invite'],  },
      ]},
    ]);
  }
};

